/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var jove__app__validation_requirement__model__SortByColumnEnum;

(function (jove__app__validation_requirement__model__SortByColumnEnum) {
  jove__app__validation_requirement__model__SortByColumnEnum["CREATED_AT"] = "created_at";
  jove__app__validation_requirement__model__SortByColumnEnum["VALIDATION_ID"] = "validation_id";
  jove__app__validation_requirement__model__SortByColumnEnum["TYPE"] = "type";
})(jove__app__validation_requirement__model__SortByColumnEnum || (jove__app__validation_requirement__model__SortByColumnEnum = {}));